var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitcherBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.586L11.596 4.9895L12.3035 5.6965L7 11L3.818 7.818L4.525 7.111L7 9.586Z",
    fill: "#FD9A07"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9.586L11.596 4.9895L12.3035 5.6965L7 11L3.818 7.818L4.525 7.111L7 9.586ZM6.99998 9.0203L11.5959 4.4239L12.8693 5.6964L7 11.5657L3.25231 7.818L4.525 6.54531L6.99998 9.0203Z",
    fill: "#FD9A07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitcherBadge);
export default __webpack_public_path__ + "static/media/switcher_badge.f741a0fb0df436f07dc00394b73d5adf.svg";
export { ForwardRef as ReactComponent };